import Vue from 'vue';
import VueRouter from 'vue-router';
import goTo from 'vuetify/es5/services/goto';
import api from '@/api';

import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Settings from '@/views/Settings.vue';
import Reset from '@/views/Reset.vue';
import Resources from '@/views/Resources.vue';
import Trophies from '@/views/Trophies.vue';
import Module from '@/views/Module.vue';

Vue.use(VueRouter);

const refresh = () => {
    window.location.href = '/';
};

const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/login', name: 'login', component: Login },
    {
        path: '/logout',
        beforeEnter: (to, from, next) => {
            api.get('/logout').then(refresh).catch(refresh);
        }
    },
    {
        path: '/logout/all',
        beforeEnter: (to, from, next) => {
            api.get('/logout?all').then(refresh).catch(refresh);
        }
    },
    { path: '/settings', name: 'settings', component: Settings },
    { path: '/trophies', name: 'trophies', component: Trophies },
    { path: '/resources', name: 'resources', component: Resources },
    { path: '/reset', name: 'reset', component: Reset },
    { path: '/m/:module/:page', name: 'module', component: Module },
    { path: '/admin', name: 'admin', component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue') },
    { path: '*', redirect: '/' }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
    routes
});

export default router;
